import './_okendo-reviews.scss';

export default () => {};
